/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendNextAppointmentReminder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function SendNextAppointmentReminder({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/Content/Related/Content/SendNextAppointmentReminder",
  onChange
  
}) {
let newPhoneAppointmentRemindersValueData = fromData.useDataValue({ viewPath,
context: 'new_phone',
path: 'appointment_reminders',
})
let newPhoneSendNextAppointmentReminderValueData = fromData.useDataValue({ viewPath,
context: 'new_phone',
path: 'send_next_appointment_reminder',
})
let newPhoneSendNextAppointmentReminderChangeData = fromData.useDataChange({ viewPath,
context: 'new_phone',
path: 'send_next_appointment_reminder',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="new_phone.appointment_reminders"
 disabled={!newPhoneAppointmentRemindersValueData}
 data="new_phone.send_next_appointment_reminder"
 value={newPhoneSendNextAppointmentReminderValueData}
 onChange={newPhoneSendNextAppointmentReminderChangeData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Send next appointment reminder"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}